import React from 'react';
import './App.css';
import Mappa from './Mappa/Mappa.js'
import { Provider} from 'react-redux'
import store from './redux/store'
//import ReactGA from 'react-ga';

function App() {
  //GOOGLE ANALYTICS
  /*const TRACKING_ID = process.env.REACT_APP_TRACKING_ID; //"UA-129878-23"; 
  ReactGA.initialize(TRACKING_ID, { gaOptions: { cookieFlags: "SameSite=None;Secure" } });
  ReactGA.set({anonymizeIp: true});*/
  React.useEffect(() => {
    document.title = process.env.REACT_APP_TITLE; // "Muoversi in Sardegna"
    //TO INITIALIZE CUSTOM API_KEY
    const queryString = window.location.search  
    const urlParams = new URLSearchParams(queryString)
    if(urlParams.has("operator")) window.tp_operator = urlParams.get('operator')
    if(urlParams.has("apikey")) window.tp_key = urlParams.get('apikey')
    //window.tp_ref = document.referrer
    //if (document.referrer && document.referrer !== "") window.tp_headers = {'x-api-key': window.tp_key?window.tp_key:process.env.REACT_APP_API_KEY, 'x-origin': document.referrer}
    //else 
    window.tp_headers = {'x-api-key': window.tp_key?window.tp_key:process.env.REACT_APP_API_KEY}

    window.addEventListener('message', function(event) {
      if (typeof event.data === 'string' && event.data.startsWith('http')) { // O una validazione più specifica se invii oggetti complessi
        let parentContainerOrigin = event.data;
        window.tp_headers = {'x-api-key': window.tp_key?window.tp_key:process.env.REACT_APP_API_KEY, 'x-origin': parentContainerOrigin}
        console.log(`Origine pagina contenitore ricevuta con successo: ${parentContainerOrigin}`);
      } else {
        console.warn('Messaggio ricevuto da origine fidata ma con dati inattesi:', event.data);
      }
    });

    // script WEBANALYTICS
    var _paq = window._paq = window._paq || [];
    /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
    _paq.push(['trackPageView']);
    _paq.push(['enableLinkTracking']);
    (function() {
      var u="https://ingestion.webanalytics.italia.it/";
      _paq.push(['setTrackerUrl', u+'matomo.php']);
      _paq.push(['setSiteId', process.env.REACT_APP_TRACKING_ID]);
      var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
      g.type='text/javascript'; g.async=true; g.src=u+'matomo.js'; s.parentNode.insertBefore(g,s);
    })();
    // FINE script WEBANALYTICS
 }, []);
  return (
    <Provider store={store}>
      <div className="App">
        <header className="App-header">
        <Mappa />
        </header>
      </div>
    </Provider>
  );
}

export default (App);
